<script setup lang="ts">

const target = ref<HTMLDivElement | null>(null)
const targetIsVisible = ref(false)
const stopRef = ref<() => void>(() => {})
const UI_REFRESH_RATE = 100

const { stop } = useIntersectionObserver(target, ([entry]) => {
    if (entry?.isIntersecting) {
        stopRef.value()
        setTimeout(() => {
            targetIsVisible.value = true
            
        }, UI_REFRESH_RATE)
    }
})
stopRef.value = stop

</script>

<template>
  <div
    ref="target"
    style="min-width: 1px; min-height: 1px;"
    :class="{loaded: targetIsVisible}"
  >
    <!-- TODO: skeleton slot -->
    <slot v-if="targetIsVisible" />
  </div>
</template>

<style lang="scss" scoped>
div {
  opacity: 0;
  transition: opacity .2s .2s ease;
  &.loaded {
    opacity: 1;
  }
}
</style>